module.exports = "/_next/static/images/header-logo-cb4f69ee8720795e87f0ac981c0e427f.svg";